"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
/**
 * Clear a notification
 */
function clearNotification() {
  return (0, _utils.actionCreator)(_types.CLEAR_NOTIFICATION, {
    show: false
  });
}
var _default = exports["default"] = clearNotification;